import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { MainMapModule } from 'app/shared/components/main-map/main-map.module';
import { OverlayMaskModule } from 'app/shared/components/overlay-mask/overlay-mask.module';
import { SideMenuModule } from 'app/shared/components/side-menu/side-menu.module';
import { SlideToggleModule } from 'app/shared/components/slide-toggle/slide-toggle.module';
import { HomePageComponent } from './home.page';
import { CookiesDisclaimerComponent } from '@components/cookies-disclaimer/cookies-disclaimer.component';

@NgModule({
  imports: [
    CommonModule,
    MainMapModule,
    SideMenuModule,
    SlideToggleModule,
    ButtonModule,
    OverlayMaskModule,
    CookiesDisclaimerComponent,
  ],
  declarations: [HomePageComponent],
  exports: [HomePageComponent],
})
export class HomePageModule {}
